import { Inbox, InboxService } from '../../inbox';
import {MAT_DIALOG_DATA, MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {MessageService, ConfirmationService} from 'primeng/api';
import {Component, OnInit, Input, EventEmitter, Output, Inject} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import {AlertService, AuthenticationService, ConstantService} from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { User } from '@app/_models';
import { Subscription } from 'rxjs';
import {TaskComponent} from '@app/_components/task/task/task.component';
import {Msg, MsgService} from '@app/_components/msg';
import {TaskListComponent} from '@app/_components/task/task-list/task-list.component';
import {MsgRecipient} from '@app/_components/msg-recipient/msg-recipient';
import {MsgTemplateService} from '@app/_components/msg-template/msg-template.service';
@Component({
    selector: 'app-inbox-sms',
    templateUrl: './inbox-sms.component.html',
    styleUrls: ['./inbox-sms.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class InboxSmsComponent implements OnInit {

	currentUser: User;
	currentUserSubscription: Subscription;
	imapConfigId: any;
  fromTask = false;
  defaultContacts: any = [];
 countries: any;
  @Input() msgTopic: number;
  @Input() msgTopicId: number;
  @Input() formReadOnly = true;
  @Input() showClose = true;
  @Input() inbox: Inbox;
  @Input() msgId: any;
  @Output() doAdd = new EventEmitter<any>();
  @Output() doUpdate = new EventEmitter<any>();
  @Output() doUpdateAndDontClose = new EventEmitter<any>();
  @Output() doDelete = new EventEmitter<any>();
  @Output() tagsChanged = new EventEmitter<{ msgId: number; tags: any[] }>();
	msgTemplates: any;
	openingReservation: { [key: number]: boolean } = {};
	
	// Conversation chat properties
	conversationMessages: any[] = [];
	currentPage: number = 0;
	pageSize: number = 10;
	loadingConversation: boolean = false;
	hasMoreMessages: boolean = true;
	conversationFrom: string = '';
	conversationTo: string = '';
	showSmsDetailDialog: boolean = false;
	selectedSmsDetail: any = null;
	loadingSmsDetail: boolean = false;
	
	uploadedFiles: any[] = [];
	readonly maxAttachmentTotalSize = 10 * 1024 * 1024;

	constructor(
		private primengConfig: PrimeNGConfig,
		private inboxService: InboxService,
		private alertService: AlertService,
		private messageService: MessageService,
		private constantService: ConstantService,
		private confirmationService: ConfirmationService,
		private authenticationService: AuthenticationService,
		private formBuilder: UntypedFormBuilder,
    private dialog: MatDialog,
    private msgService: MsgService,
		private msgTemplateService: MsgTemplateService,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.inbox = data.inbox,
      this.fromTask = data.fromTask,
			this.statuses = inboxService.statuses;
    if ( data.msgTopicId){
      this.msgTopicId = data.msgTopicId;
    }
    if ( data.msgTopic){
      this.msgTopic = data.msgTopic;
    }
		this.countries = this.constantService.countries;
		this.currentUserSubscription = this.authenticationService.currentUser.subscribe(user => {
			this.currentUser = user;
		});
		try {
      this.defaultContacts = [];
      if ( this.inbox && this.inbox.senderEmail){
        this.defaultContacts.push({emailAddress: this.inbox.senderEmail});
      }
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}
	// data
	inboxId: number;
	selectedMsgRecipients: any[] = [];
	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;
	isSendEnable: boolean;
	isReplyEnable: boolean;
	statuses: any;

	validationMessages = {
		'inboxId': [],
		'status': [],
		'inboxDate': [],
		'isInbox': [],
		mobileNum: [{ type: 'required', message: 'Required' }],
		mobileCountryCode: [],
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();
		// if we were passed the whole inbox object
		if (this.inbox && this.inbox?.msgId) {
			this.isSendEnable = false;
			this.isReplyEnable = true;
			this.inboxId = this.inbox.msgId;
			this.fixDates();
			this.form1.patchValue(this.inbox);
			this.form1.patchValue({ mobileText: '' });
			this.applyPrimaryRecipientToForm();
			this.imapConfigId = this.form1.value.imapConfigId;
		} else {
			this.isSendEnable = true;
			this.formReadOnly = false;
		}
		if (this.inbox) {
			this.form1.patchValue(this.inbox);
			this.form1.patchValue({ mobileText: '' });
			this.applyPrimaryRecipientToForm();
		}
		this.fetchAllTemplates();
		
		setTimeout(() => {
			this.loadConversation(true);
		}, 300);
	}

	onSmsTagsSelected(tags: any[]): void {
		if (this.inboxId) {
			this.tagsChanged.emit({ msgId: this.inboxId, tags: tags ?? [] });
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.inboxId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete();
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.inboxService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.inbox = res.data.inbox;
						this.doAdd.emit(this.inbox);
					},
					(err: any) => {
						console.log('inbox-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}
	formUpdate() {
		console.log('inbox: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.inboxService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.inbox = res.data.inbox;
						this.doUpdate.emit(this.inbox);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.inboxService.delete(this.inbox.msgId)
				.subscribe(
					(res: any) => {
						console.log('inbox-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.inbox);
					},
					(err: any) => {
						console.log('inbox-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.inbox.createDate = moment(this.inbox.createDate).toDate();
	}
	replyMail() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.isSendEnable = true;
			this.isReplyEnable = false;
      this.formReadOnly = false;
			this.form1.get('imapConfigId').setValue(String(this.imapConfigId));
			this.form1.patchValue({ mobileText: '', parentMsgId: this.form1.value.msgId });
			this.applyPrimaryRecipientToForm();

		} catch (error) {
			this.alertService.error(error);
		}
	}

	cancelReply() {
		try {
			this.isSendEnable = false;
			this.isReplyEnable = true;
			this.formReadOnly = true;
			this.form1.patchValue(this.inbox);
			this.applyPrimaryRecipientToForm();
		} catch (error) {
			this.alertService.error(error);
		}
	}

	private applyPrimaryRecipientToForm(): void {
		const isSentByUs = this.inbox?.msgFolder === 1;
		console.log('isSentByUs: ', isSentByUs,this.inbox);
		const customerRecipient = isSentByUs
			? this.inbox?.msgRecipientAPIList?.[0]
			: {
				mobileNum: this.inbox?.senderMobileNum,
				mobileCountryCode: this.inbox?.senderCountryCode
			};

		if (customerRecipient?.mobileNum) {
			let mobileNum = String(customerRecipient.mobileNum).trim();
			let countryCode = customerRecipient?.mobileCountryCode ? String(customerRecipient.mobileCountryCode).trim() : '';
			mobileNum?.startsWith(countryCode) ? mobileNum = mobileNum.replace(countryCode, '').trim() : '';
			this.form1.patchValue({
				mobileNum: mobileNum,
				mobileCountryCode: countryCode || this.form1.value.mobileCountryCode
			});
		}
	}

	openReservation(reservationId: number) {
		this.openingReservation[reservationId] = true;
		this.inboxService.getOrderIdByReservationId(reservationId).subscribe(
			(res: any) => {
				window.open(`https://admin.kbmhawaii.com/order/${res?.data?.orderId}`, '_blank');
				this.openingReservation[reservationId] = false;
			},
			(err: any) => {
				console.log('Error fetching order ID: ' + JSON.stringify(err));
				this.openingReservation[reservationId] = false;
			}
		);
	}

	addAndSendMsg() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			const emailRecipients: MsgRecipient[] = [];
			const msgRecipient = new MsgRecipient();
			msgRecipient.mobileNum = this.form1.value.mobileNum;
			msgRecipient.mobileCountryCode = this.form1.value.mobileCountryCode;
			emailRecipients.push(msgRecipient);
			this.form1.value.msgRecipientAPIList = emailRecipients;
			this.form1.value.topic = 'Guest Communication send SMS';
			this.form1.value.topicId = 0;
			this.form1.value.msgId = null;
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			let msg: Msg = new Msg();
			msg.msgRecipientAPIList = emailRecipients;
			msg.topic = 17000; // 'Guest Communication send SMS'
			msg.topicId = 0;
			msg.mobileText = this.form1.value.mobileText || '';
			msg.topic = this.msgTopic;
			msg.topicId = this.msgTopicId;
			this.buildSmsAttachments().then(smsAttachments => {
				(msg as any).emailAttachments = smsAttachments && smsAttachments.length > 0 ? smsAttachments : [];
				console.log('msg conversation: ', msg);
				this.msgService.addAndSendMail(msg).subscribe(
				(res: any) => {
					console.log('property-add SUCCESS: ' + JSON.stringify(res));
					this.messageService.add({
						severity: 'success',
						summary: 'Success',
						detail: res.message,
					});
					this.inbox = res.data.msgResponse;
					if (this.inbox) {
						this.doAdd.emit(this.inbox);
						this.form1.patchValue({ mobileText: '' });
						this.uploadedFiles = [];
						this.onMessageSent();
					}
					else{
						let alertMsg = '';
						if ( this.inbox.statusMsg ){
							try{
								let statusMsg = JSON.parse(this.inbox.statusMsg);
								if (statusMsg.errors && statusMsg.errors.length > 0){
									statusMsg.errors.forEach(function(obj) { alertMsg += obj.message + '<br>'; });
									this.alertService.error('Faied to send mail: ' + alertMsg);
								}
							} catch (error) {
								this.alertService.error(error);
							}
						}
						else {
							this.alertService.error('Faied to send mail: ' + this.inbox.statusMsg);
						}

					}
					this.formLoading = false;
					// this.loadConversation(true);
				},
				(err: any) => {
					// Do NOT reset formLoading on error — a 504 means the SMS/mail may have been sent.
					// Keep button disabled to prevent a duplicate message from being sent.
					console.log('msg-add FAIL: ' + JSON.stringify(err));
					let errorMessage = "";
					if (err?.errors && err?.errors.length > 0) {
						for (let i = 0; i < err?.errors.length; i++) {
							errorMessage += err?.errors[i]?.message + ', ';
						}
						errorMessage = errorMessage.slice(0, -2);
					}
					else{
						errorMessage = (err?.message || 'Failed to send mail/SMS') + ' — message may have been sent. Refresh before retrying.';
					}
					this.alertService.error(errorMessage);
				},
				() => {
					this.formLoading = false;
				}
			);
			}).catch(err => {
				console.error('Failed to build SMS attachments:', err);
				this.formLoading = false;
				this.alertService.error('Failed to prepare attachments.');
			});
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			msgId: [],
			sentDate: [],
			receivedDate: [],
			senderName: [],
			senderEmail: [],
			senderMobileNum: ['9999999999'],
			senderCountryCode: ['+1'],
			mobileNum: [{ type: 'required', message: 'Required' }],
			mobileCountryCode: [],
			preHeader: [],
			mobileText: [],
			headers: [],
			status: [],
			statusMsg: [],
			confId: [],
			trackingId: [],
			opsNotes: [],
			campaignVars: [],
			msgRecipientAPIList: [],
			topic: [],
			topicId: [],
			toEmails: [],
			ccEmails: [],
			bccEmails: [],
			imapConfigId: [],
		});
	}

  openCreateTask(selectedNode: Inbox) {
    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.width = '100vw';
    dialogConfig.height = '100vh';
    dialogConfig.maxWidth = '100vw';
    dialogConfig.maxHeight = '100vh';
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    let sel = selectedNode as object;
    // pass data, ie rateBuicket: this.shortTermRentalId,
	  let custTaskApi = {name: selectedNode.subject};
    dialogConfig.data = {
      title: 'Assign Task',
      isModal: true,
      action: 'create',
      purpose: 'createmailtask',
	 taskApi: custTaskApi,
      msg: sel as Msg
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(TaskComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
    dialogRef.componentInstance.doAdd.subscribe(
      data => {
        console.log('Dialog output:', data);
        let msg  =  new Msg();
        let taskAPI = {
          taskId: undefined
        };
        // @ts-ignore
        msg.msgId = sel?.msgId;
        taskAPI.taskId = data.taskId;
        msg.taskAPI = taskAPI;
        try {
          this.msgService.findById(msg.msgId).subscribe(
            (res: any) => {
              console.log('property-update SUCCESS: ' + JSON.stringify(res));
				this.inbox = res?.data?.msg;
				this.doUpdateAndDontClose.emit(this.inbox);
              this.messageService.add({
                severity: 'success',
                summary: 'Task Created',
                detail: res.message,
              });
            },
            (err: any) => {
              console.log('property-update FAIL: ' + JSON.stringify(err));
              this.alertService.error(err);
            },
            () => {
            }
          );
        } catch (error) {
          console.log('Form Invalid: ' + JSON.stringify(error));
          this.alertService.error(error);
        }
        dialogRef.close();
      });
  }

  archiveMsg(selectedNode: Inbox) {
    try {
      let msg  =  new Msg();
      let sel = selectedNode as object;
      // @ts-ignore
      msg.msgId = sel?.msgId;
      msg.msgFolder = 2;  // 2 is for archive folder
      this.msgService.archiveMsg(msg).subscribe(
        (res: any) => {
          console.log('property-update SUCCESS: ' + JSON.stringify(res));
          this.messageService.add({
            severity: 'success',
            summary: 'Archived',
            detail: res.message,
          });
          this.doUpdateAndDontClose.emit(this.inbox);
        },
        (err: any) => {
          console.log('property-update FAIL: ' + JSON.stringify(err));
          this.alertService.error(err);
        },
        () => {
        }
      );
    } catch (error) {
      console.log('Form Invalid: ' + JSON.stringify(error));
      this.alertService.error(error);
    }
  }
	openViewTask(rowData: any) {
		if (rowData.taskAPIList?.length > 1) {
			const dialogConfig = new MatDialogConfig();
			// settings
			dialogConfig.width = '100%';
			dialogConfig.height = '100%';
			dialogConfig.maxWidth = '1600px';
			dialogConfig.maxHeight = '800px';
			dialogConfig.disableClose = false;
			dialogConfig.autoFocus = true;
			dialogConfig.hasBackdrop = true;
			// pass data, ie rateBuicket: this.shortTermRentalId,
			dialogConfig.data = {
				title: 'Mail Tasks',
				isModal: true,
				parentMsgId: rowData.msgId,
				fromMail: true,
				showFilter: false,
				showPagination: false,
				outlineNewButton: false,
			};
			const dialogRef = this.dialog.open(TaskListComponent, dialogConfig);
		} else {
			const dialogConfig = new MatDialogConfig();
			dialogConfig.width = '100vw';
			dialogConfig.height = '100vh';
			dialogConfig.maxWidth = '100vw';
			dialogConfig.maxHeight = '100vh';
			dialogConfig.disableClose = false;
			dialogConfig.autoFocus = true;
			dialogConfig.hasBackdrop = true;
			dialogConfig.data = {
				title: 'Assign Task',
				isModal: true,
				taskApi: rowData?.taskAPIList[0],
				fromMail: false
			};

			const dialogRef = this.dialog.open(TaskComponent, dialogConfig);
			dialogRef.componentInstance.doAdd.subscribe(
				data => {
					console.log('Dialog output:', data);
					dialogRef.close();
				});
		}
	}
	fetchAllTemplates() {
		if (!this.msgTemplates || this.msgTemplates === undefined || this.msgTemplates.length < 1) {
			try {
				this.msgTemplateService.findAllWithoutPage()
					.subscribe(
						res => {
							console.log('employee Profiles: ' + JSON.stringify(res));
							this.msgTemplates = [];
							this.msgTemplates = res.data.msgTemplates;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			return (this.msgTemplates);
		}
	}
	selectTemplate(event)
	{
		console.log('Template selected:', event);
		const selectedTemplateId = event.value;
		if (!selectedTemplateId) {
			return;
		}
		const selectedTemplate = this.msgTemplates?.find((t: any) => 
			t.msgTemplateId === selectedTemplateId || t.msgTemplateId === Number(selectedTemplateId)
		);
		
		if (selectedTemplate && selectedTemplate.mobileText) {
			this.form1.get('mobileText')?.setValue(selectedTemplate.mobileText, {
				emitEvent: false
			});
			setTimeout(() => {
				const textarea = document.querySelector('.sms-chat-textarea') as HTMLTextAreaElement;
				if (textarea) {
					textarea.focus();
					const length = textarea.value.length;
					textarea.setSelectionRange(length, length);
				}
			}, 100);
		} else {
			console.warn('Template not found or has no mobileText. Template ID:', selectedTemplateId, 'Available templates:', this.msgTemplates);
		}
	}

	loadConversation(clear: boolean = false): void {
		if (!this.inbox) return;
		
		let senderNum = '';
		let recipientNum = '';
		
		if (this.inbox.senderMobileNum) {
			// const countryCode = this.inbox.senderCountryCode || '+1';
			
			// senderNum = countryCode.startsWith('+') 
			// 	? `${countryCode}${this.inbox.senderMobileNum}` 
			// 	: `+${countryCode}${this.inbox.senderMobileNum}`;
			senderNum = this.inbox.senderMobileNum;
		}
		
		if (this.inbox.msgRecipientAPIList && this.inbox.msgRecipientAPIList.length > 0) {
			const recipient = this.inbox.msgRecipientAPIList[0];
			if (recipient.mobileNum) {
				// const countryCode = recipient.mobileCountryCode || '+1';
				// recipientNum = countryCode.startsWith('+') 
				// 	? `${countryCode}${recipient.mobileNum}` 
				// 	: `+${countryCode}${recipient.mobileNum}`;
				recipientNum = recipient.mobileNum;
			}
		}
		
		if (!recipientNum && this.form1 && this.form1.value.mobileNum) {
			// const countryCode = this.form1.value.mobileCountryCode || '+1';
			// recipientNum = countryCode.startsWith('+') 
			// 	? `${countryCode}${this.form1.value.mobileNum}` 
			// 	: `+${countryCode}${this.form1.value.mobileNum}`;
			recipientNum = this.form1.value.mobileNum;
		}
		
		if (!senderNum || !recipientNum) {
			console.log('Cannot load conversation: missing sender or recipient number', { senderNum, recipientNum });
			return;
		}
		
		this.conversationFrom = senderNum;
		this.conversationTo = recipientNum;
		if (clear) {
			this.currentPage = 0;
			this.conversationMessages = [];
		}
		this.hasMoreMessages = true;
		this.fetchConversationMessages();
	}

	fetchConversationMessages(): void {
		if (this.loadingConversation || !this.hasMoreMessages) return;
		
		this.loadingConversation = true;
		this.inboxService.findConversation(
			this.conversationFrom, 
			this.conversationTo, 
			this.currentPage, 
			this.pageSize,
			null, // sortBy
			null, // sortOrder
			null, // multiSortMeta
			null, // globalFilter
			null  // filters
		)
			.subscribe(
				(res: any) => {
					console.log('Conversation loaded: ' + JSON.stringify(res));
					if (res.data && res.data.msgs) {
						const newMessages = res.data.msgs || [];
						
						const reversedNewMessages = [...newMessages].reverse();
						
						if (this.currentPage === 0) {
							this.conversationMessages = reversedNewMessages;
							setTimeout(() => {
								this.scrollToBottom();
								const textarea = document.querySelector('.sms-chat-textarea') as HTMLTextAreaElement;
								if (textarea) {
									textarea.focus();
								}
							}, 200);
						} else {
							this.conversationMessages = [...reversedNewMessages, ...this.conversationMessages];
							const chatContainer = document.getElementById('sms-chat-messages');
							if (chatContainer) {
								const oldScrollHeight = chatContainer.scrollHeight;
								setTimeout(() => {
									const newScrollHeight = chatContainer.scrollHeight;
									chatContainer.scrollTop = newScrollHeight - oldScrollHeight;
								}, 50);
							}
						}
						
						if (res.page) {
							this.hasMoreMessages = res.page.pageNumCurrent < res.page.pageNumLast;
						} else {
							this.hasMoreMessages = false;
						}
					} else {
						this.hasMoreMessages = false;
					}
					this.loadingConversation = false;
				},
				(err: any) => {
					console.log('Failed to load conversation: ' + JSON.stringify(err));
					this.alertService.error(err);
					this.loadingConversation = false;
					this.hasMoreMessages = false;
				}
			);
	}

	loadMoreMessages(): void {
		if (this.loadingConversation || !this.hasMoreMessages) return;
		
		this.currentPage++;
		this.fetchConversationMessages();
	}

	onScrollUp(event: any): void {
		const element = event.target;
		if (element.scrollTop < 50 && this.hasMoreMessages && !this.loadingConversation) {
			this.loadMoreMessages();
		}
	}

	scrollToBottom(): void {
		const chatContainer = document.getElementById('sms-chat-messages');
		if (chatContainer) {
			chatContainer.scrollTop = chatContainer.scrollHeight;
		}
	}

	formatMessageDate(date: any): string {
		if (!date) return '';
		return moment(date).format('MMM DD, YYYY hh:mm A');
	}

	onMessageSent(): void {
		setTimeout(() => {
			this.currentPage = 0;
			this.conversationMessages = [];
			this.hasMoreMessages = true;
			this.fetchConversationMessages();
			setTimeout(() => {
				const textarea = document.querySelector('.sms-chat-textarea') as HTMLTextAreaElement;
				if (textarea) {
					textarea.focus();
					textarea.value = '';
				}
			}, 2000);
		}, 1500);
	}

	sendMessageFromChat(): void {
		if (!this.form1.get('mobileText')?.value || this.formLoading) return;

		// Do not overwrite recipient fields here.
		// addAndSendMsg() must use the currently selected/entered "To" number from the form.
		
		if (!this.isSendEnable) {
			this.isSendEnable = true;
			this.isReplyEnable = false;
			this.formReadOnly = false;
		}
		
		this.addAndSendMsg();
	}

	onChatInputEnter(event: KeyboardEvent): void {
		if (!event.shiftKey) {
			event.preventDefault();
			this.sendMessageFromChat();
		}
	}

	openSmsInfo(message: any): void {
		const msgId = message?.msgId || message?.msgID;
		const msgRecipientId = message?.msgRecipientId || message?.msgReciepentId || message?.msgRecipientAPIId;
		if (!msgId || !msgRecipientId) {
			this.alertService.error('Unable to load SMS details: missing message identifiers.');
			return;
		}
		this.loadingSmsDetail = true;
		this.selectedSmsDetail = null;
		this.showSmsDetailDialog = true;
		this.inboxService.getSmsDetail(msgId, msgRecipientId).subscribe(
			(res: any) => {
				this.loadingSmsDetail = false;
				this.selectedSmsDetail = res?.data || res;
			},
			(_err: any) => {
				this.loadingSmsDetail = false;
				this.selectedSmsDetail = {
					msgId,
					from: message?.mobileNumber || message?.from,
					sentDate: message?.messageDateTime || message?.sentDate,
					mobileText: message?.mobileText,
					_noTrackingId: true
				};
			}
		);
	}

	openSmsAttachment(att: any): void {
		try {
			const filename = att?.fileName || att?.filename || 'attachment';

			const directUrl = att?.mediaUrl;
			if (directUrl) {
				window.open(directUrl, '_blank');
				return;
			}

			if (att?.content) {
				const mimeType = att?.type || 'application/octet-stream';
				const byteCharacters = atob(att.content);
				const byteNumbers = new Array(byteCharacters.length);
				for (let i = 0; i < byteCharacters.length; i++) {
					byteNumbers[i] = byteCharacters.charCodeAt(i);
				}
				const byteArray = new Uint8Array(byteNumbers);
				const blob = new Blob([byteArray], { type: mimeType });
				const url = URL.createObjectURL(blob);
				window.open(url, '_blank');
				setTimeout(() => URL.revokeObjectURL(url), 60000);
				return;
			}

			this.alertService?.error('No preview available for this attachment.');
		} catch (e) {
			console.error('Could not open SMS attachment:', e);
			this.alertService?.error('Unable to open this attachment.');
		}
	}

	onFileSelected(event: Event): void {
		const input = event.target as HTMLInputElement;
		const files = input?.files;
		if (!files || files.length === 0) return;
		const newFiles = Array.from(files);
		const currentTotal = this.uploadedFiles.reduce((sum, f) => sum + (f.size || 0), 0);
		let runningTotal = currentTotal;
		const toAdd: File[] = [];
		let limitReached = false;
		for (const file of newFiles) {
			if (runningTotal + file.size > this.maxAttachmentTotalSize) {
				limitReached = true;
				break;
			}
			toAdd.push(file);
			runningTotal += file.size;
		}
		this.uploadedFiles = [...this.uploadedFiles, ...toAdd];
		if (limitReached || (toAdd.length < newFiles.length && runningTotal >= this.maxAttachmentTotalSize)) {
			this.messageService.add({ severity: 'info', summary: 'Limit reached', detail: 'Total attachments cannot exceed 10MB.', life: 3000 });
		}
		input.value = '';
	}

	removeAttachment(index: number): void {
		if (index >= 0 && index < this.uploadedFiles.length) {
			this.uploadedFiles = this.uploadedFiles.slice(0, index).concat(this.uploadedFiles.slice(index + 1));
		}
	}

	viewAttachment(file: File): void {
		try {
			const url = URL.createObjectURL(file);
			window.open(url, '_blank');
			setTimeout(() => URL.revokeObjectURL(url), 60000);
		} catch (e) {
			console.error('Could not open file for preview:', e);
			this.alertService?.error('Unable to preview this file.');
		}
	}

	isPdf(file: File): boolean {
		return file?.type === 'application/pdf';
	}

	formatFileSize(bytes: number): string {
		if (bytes == null || bytes === 0) return '0 B';
		const k = 1024;
		const sizes = ['B', 'KB', 'MB'];
		const i = Math.floor(Math.log(bytes) / Math.log(k));
		return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
	}

	private buildSmsAttachments(): Promise<Array<{ content: string; filename: string; type: string }>> {
		if (!this.uploadedFiles || this.uploadedFiles.length === 0) {
			return Promise.resolve([]);
		}
		const files = this.uploadedFiles.filter(f => f instanceof File) as File[];
		if (files.length === 0) return Promise.resolve([]);
		return Promise.all(files.map(f => this.fileToBase64Attachment(f)));
	}

	private fileToBase64Attachment(file: File): Promise<{ content: string; filename: string; type: string }> {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.onload = () => {
				const dataUrl = reader.result as string;
				const base64 = dataUrl && dataUrl.indexOf('base64,') >= 0 ? dataUrl.split('base64,')[1] : dataUrl;
				resolve({
					content: base64 || '',
					filename: file.name || 'attachment',
					type: file.type || 'application/octet-stream'
				});
			};
			reader.onerror = () => reject(reader.error);
			reader.readAsDataURL(file);
		});
	}

	insertNewLine(): void {
		const textarea = document.querySelector('.sms-chat-textarea') as HTMLTextAreaElement;
		if (textarea) {
			const start = textarea.selectionStart;
			const end = textarea.selectionEnd;
			const currentValue = this.form1.get('mobileText')?.value || '';
			// const newValue = currentValue.substring(0, start) + '\n' + currentValue.substring(end);
			this.form1.patchValue({ mobileText: currentValue });
			
			setTimeout(() => {
				textarea.selectionStart = textarea.selectionEnd = start + 1;
				textarea.focus();
			}, 0);
		}
	}
}
